import { ReservationLocalstorageSteps } from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';

export const localstorageServicesAndDiscountsFromStepThree = () => {
  let localStorageServices = [];
  let localStorageServicesStepFour = [];
  let localStorageDiscountServices = [];
  let localStorageDiscountsStepFour = [];

  const localstorageServicesAndDiscounts = JSON.parse(
    localStorage.getItem(ReservationLocalstorageSteps.THIRDSTEP) as string,
  );

  if (localstorageServicesAndDiscounts) {
    const { services, servicesStepFour, discountServices, discountServicesStepFour } =
      localstorageServicesAndDiscounts;

    localStorageServices = services;
    localStorageServicesStepFour = servicesStepFour;
    localStorageDiscountServices = discountServices;
    localStorageDiscountsStepFour = discountServicesStepFour;
  }

  return {
    localstorageServicesAndDiscounts,
    localStorageServices,
    localStorageServicesStepFour,
    localStorageDiscountServices,
    localStorageDiscountsStepFour,
  };
};
